import React from 'react';
import Select from '../Select/Select';
import { CLIENT_DOCUMENT_ISSUED_BY } from '../../constants';

const SelectClientIssuer = ({ ...props }) => {
  return <Select options={CLIENT_DOCUMENT_ISSUED_BY} label={'Кем выдан'} placeholder={'Выберите из списка'} {...props} />;
};

export default SelectClientIssuer;
